<template>
  <div :class="{'col-lg-4 col-md-4 col-sm-6 col-12 my-3':gridSystem}">
    <div class="BlogCard position-relative" :class="carousel === true ? 'carousel-w' : ''"  v-if="obj">
      <router-link @dragstart.prevent :to="'/blog/'+ this.$blogCategories.filter(item => item.id === obj.category)[0].slug + '/' + obj.slug ">
        <div dir="rtl">
            <span class="rate" v-if="obj.rates.length !== 0">{{obj.rates.reduce((a, b) => a + b, 0) / obj.rates.length}}<i class="fa-solid fa-star"></i></span>
            <img class="SimpleCardImage" :alt="obj.image" :src="$RESIZE + obj.image + '&blog=1'" />
            <div class="p-1">
              <h3>{{strLimit(obj.name,55)}}</h3>
              <p>{{strLimit(obj.description,160)}}</p>
              <p class="my-2 text-start">
                <span><i class="fa-solid fa-arrow-circle-left"></i></span>
              </p>
            </div>
        </div>
      </router-link>
    </div>
    <div class="BlogCard position-relative" v-show="!obj">
      <div dir="rtl" class="p-2">
        <img src="../assets/brand.webp" class="w-100 h-100">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BlogCard',
  props: {
    obj: JSON,
    gridSystem: {
      type: Boolean,
      default: true
    },
    carousel: Boolean
  },
  methods: {
    calPercentage: function (before, after) {
      const percentage = parseInt((before - after) * 100 / before)
      return percentage.toLocaleString('fa')
    }
  }
}
</script>
<style scoped>
.carousel-w{
  width: 300px;
}
.price{
  font-weight: bold;
}
.fa-star{
    color: gold;
}
.rate{
  font-weight: bold;
  background: #ffffff;
  color: black;
  padding: 5px 15px;
  position: absolute;
  border-radius: 9px;
  left: 7px;
  top: 7px;
}
.fa-arrow-circle-left{
  font-size: 14pt;
  color: #BDBDBD;
}
h3{
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 170%;
  text-align: right;
  color: #121212;
  margin-top:12px;
  padding:0px 12px;
}
p{
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 162%;
  text-align: right;
  color: #4F4F4F;
  padding:0px 12px;
  font-family:"IRANSans";
}
.BlogCard{
  box-shadow: 0 2px 5px 0 rgb(0 0 0 / 20%), 0 2px 10px 0 rgb(0 0 0 / 10%);
  border-radius:24px;
  height: 100% !important;
  margin: 0px auto;
  padding:0px;
  background: white;
}
.SimpleCardImage{
  width:100%;
  height:100%;
  border-radius:24px;
}
</style>
